<template>
  <div
    v-if="isSideBarTitleShown"
    class="title-section d-flex align-center ga-2"
  >
    <v-icon :class="iconClass" :icon="iconName" />
    <h2 :class="mode">{{ title }}</h2>
  </div>
</template>

<script>
export default {
  props: {
    isSideBarTitleShown: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
    mode: {
      type: String,
    },
    iconName: {
      type: String,
    },
  },
  computed: {
    iconClass() {
      return `${this.mode}-icon`;
    },
  },
};
</script>

<style scoped lang="scss">
.title-section {
  padding: 0px 20px 0px 20px;
}
.orders-icon {
  color: $ordersMainColor;
  background-color: #44a5e233;
  border-radius: 50%;
  padding: 17px;
}

.invocies-icon {
  color: $invoicesAndReturns;
  background-color: #d7f1f9;
  border-radius: 50%;
  padding: 17px;
}

.finances-icon {
  color: $cashMainColor;
  background-color: #29C4D033;
  border-radius: 50%;
  padding: 17px;
}

.cart-icon {
  color: $cartMainColor;
  background-color: #44A5E233;
  border-radius: 50%;
  padding: 17px;
}

h2 {
  font-size: 30px;
  font-weight: 700;
  line-height: 35.55px;
  text-align: right;
}

h2.orders {
  color: $ordersMainColor;
}

h2.invocies {
  color: $invoicesAndReturns;
}

h2.finances {
  color: $cashMainColor;
}

h2.cart {
  color: $cartMainColor;
}
</style>
